'use strict';

var Promise = require('bluebird');

module.exports = {

    /**
     * This will push a 'PAGE_VIEW' event using the Analytics 'pushEvent' when the
     * browserHistory changes.
     *
     * NOTE: This does not provide a way to unhook from the listen event currently.
     * If you were to call this more than once
     *
     * @param {Object} browserHistory
     * @param {function} browserHistory.listen - Listen that takes a callback when html5 history changes
     * @param {Object} analyticsProvider
     * @param {function} analyticsProvider.pushEvent - Push event that takes eventName and object bag
     */
    attachAndPushPageLoadEvents: function attachAndPushPageLoadEvents(browserHistory, analyticsProvider) {

        if (!(browserHistory && browserHistory.listen && typeof browserHistory.listen === 'function')) {

            console.warn('browserHistory must have a listen function.  No analytics will be pushed for PAGE_VIEW');
        } else if (!(analyticsProvider && analyticsProvider.pushEvent && typeof analyticsProvider.pushEvent === "function")) {

            console.warn('analyticsProvider must be passed and have pushEvent');
        } else {

            //hook into the browserHistory listen
            browserHistory.listen(function (location) {

                //push event async
                Promise.resolve().then(function () {

                    //make sure it starts with '/'
                    var pathname = location.pathname;
                    if (pathname[0] !== '/') {
                        pathname = "/" + pathname;
                    }
                    //todo: make PAGE_VIEW a constant so people can reference it?
                    analyticsProvider.pushEvent("PAGE_VIEW", { url: pathname });
                });
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/Helper.js
// module id = 861
// module chunks = 0